import { createBrowserHistory } from 'history';

// Create browser history to use in the Redux store
const baseElement = document.getElementsByTagName('base');
let baseUrl = '';

if (baseElement && baseElement.length > 0) {
    baseUrl = baseElement[0].getAttribute('href');
}

const history = createBrowserHistory({ basename: baseUrl });

export default history;